__turbopack_context__.v({
  "actions": "styles-module__t3siJa__actions",
  "body": "styles-module__t3siJa__body",
  "copy": "styles-module__t3siJa__copy",
  "heading": "styles-module__t3siJa__heading",
  "panel": "styles-module__t3siJa__panel",
  "primary": "styles-module__t3siJa__primary",
  "secondary": "styles-module__t3siJa__secondary",
  "section": "styles-module__t3siJa__section",
});
